import { useState } from 'react'
import Panel from '../ui/Panel'
import Button from '../ui/Button'
import LatencyRanking from '../charts/LatencyRanking'
import BrowserSetup from '../features/doh/BrowserSetup'
import AddResolverDialog from '../features/doh/AddResolverDialog'
import { useDohSpeed } from '../hooks/useDohSpeed'
import { doh } from '../content/site'
import styles from './DohSpeed.module.css'

export default function DohSpeed() {
    const [hostname, setHostname] = useState<string>(doh.form.defaultHost)
    const [submitted, setSubmitted] = useState<string>(doh.form.defaultHost)
    const { probes, running, servers, rerun, addCustom, dropCustom } = useDohSpeed(submitted)
    const [dialogOpen, setDialogOpen] = useState(false)

    return (
        <>
            <header className={styles.intro}>
                <h1>{doh.heading}</h1>
                <p className={styles.lede}>{doh.intro[0]}</p>
                {/* the supporting paragraphs run in two columns so the header
                    fills the page width instead of leaving a tall void to the
                    right of a narrow prose measure */}
                <div className={styles.introCols}>
                    {doh.intro.slice(1).map((p) => (
                        <p key={p} className={styles.para}>{p}</p>
                    ))}
                </div>
            </header>

            <Panel title="Lookup">
                <form
                    className={styles.form}
                    onSubmit={(e) => { e.preventDefault(); setSubmitted(hostname); rerun() }}
                >
                    <span className={styles.field}>
                        <label htmlFor="doh-host">{doh.form.label}</label>
                        <input
                            id="doh-host"
                            className={styles.input}
                            value={hostname}
                            onChange={(e) => setHostname(e.target.value)}
                            spellCheck={false}
                            autoComplete="off"
                        />
                    </span>
                    <Button type="submit" variant="primary" disabled={running}>
                        {running ? 'testing…' : doh.form.test}
                    </Button>
                    <Button onClick={() => setDialogOpen(true)}>{doh.form.add}</Button>
                </form>
            </Panel>

            <div className={styles.section}>
                {servers.isError ? (
                    <Panel title="DoH latency">
                        <p className={styles.muted}>Could not load the resolver list.</p>
                    </Panel>
                ) : (
                    <LatencyRanking probes={probes} onRemoveCustom={dropCustom} />
                )}
            </div>

            <div className={styles.section}>
                <Panel title="Reading these numbers">
                    {doh.speedIntro.map((p) => <p key={p} className={styles.para}>{p}</p>)}
                </Panel>
            </div>

            <div className={styles.section}>
                <BrowserSetup />
            </div>

            <AddResolverDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onAdded={addCustom}
            />
        </>
    )
}
